
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#A0A5BA"}},[_c('path',{attrs:{"d":"M22.516 17.014l-2.868-1.273a.252.252 0 01-.148-.229v-1.143a.247.247 0 01.074-.177 3.308 3.308 0 00.779-2.23.252.252 0 01.088-.177 1.874 1.874 0 00.538-1.4 1.575 1.575 0 00-.317-1.014.251.251 0 01-.034-.265c.254-.54.309-1.15.156-1.727-.354-1.444-2.227-1.979-3.747-1.859a5.552 5.552 0 00-1.985.2.25.25 0 00-.171.184c-.033.148-.069.29-.1.425a.247.247 0 00.016.173c.22.469.33.98.323 1.498a3.275 3.275 0 01-.658 2.03.247.247 0 00-.05.115 5.448 5.448 0 01-.7 1.973.251.251 0 00-.034.156c.037.397.128.786.271 1.158a.248.248 0 00.14.139l2.256.894a4.974 4.974 0 013.155 4.649V22c0 .075-.004.149-.012.223a.247.247 0 00.147.256.25.25 0 00.102.021H23.5a.5.5 0 00.5-.5v-2.7a2.5 2.5 0 00-1.484-2.286z"}}),_c('path',{attrs:{"d":"M18 19.114a3.482 3.482 0 00-2.211-3.255l-4.131-1.637a.249.249 0 01-.158-.232v-1.55a.25.25 0 01.108-.206 3.467 3.467 0 001.373-2.744.252.252 0 01.1-.181A1.592 1.592 0 0013.62 8a1.7 1.7 0 00-.412-1.2.252.252 0 01-.059-.249 6.204 6.204 0 00.336-3.174C13.139 1.992 11.256 1.5 9.75 1.5c-1.292 0-2.86.362-3.5 1.34a.252.252 0 01-.206.114 1.413 1.413 0 00-1.069.433c-.713.769-.357 2.253-.1 3.161a.251.251 0 01-.065.244 1.2 1.2 0 00-.207.279c-.15.286-.227.606-.223.929a1.593 1.593 0 00.539 1.309.251.251 0 01.1.181 3.467 3.467 0 001.373 2.744.253.253 0 01.108.206v1.551a.249.249 0 01-.158.232L2.206 15.87A3.481 3.481 0 000 19.122V22a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-2.886z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    